import { render, staticRenderFns } from "./DialogInformativoQuantidadeCotasDisponiveis.vue?vue&type=template&id=6e5b3762&scoped=true&"
import script from "./DialogInformativoQuantidadeCotasDisponiveis.vue?vue&type=script&lang=js&"
export * from "./DialogInformativoQuantidadeCotasDisponiveis.vue?vue&type=script&lang=js&"
import style0 from "./DialogInformativoQuantidadeCotasDisponiveis.vue?vue&type=style&index=0&id=6e5b3762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5b3762",
  null
  
)

export default component.exports